// pages/_app.js
import '../styles/globals.css';
import { CssBaseline, ThemeProvider } from '@mui/material';
import { useMemo, useState } from 'react';
import ThemeModeContext from '../context/ThemeContext';
import { AuthProvider } from '../context/AuthContext';
import { lightTheme, darkTheme } from '../theme/theme';

function MyApp({ Component, pageProps }) {
  const [mode, setMode] = useState('light');
  const theme = useMemo(() => (mode === 'light' ? lightTheme : darkTheme), [mode]);
  const toggleTheme = () => setMode((prev) => (prev === 'light' ? 'dark' : 'light'));

  // 👇 Динамический layout — берём либо указанный, либо дефолт
  const getLayout = Component.getLayout || ((page) => page);

  return (
    <ThemeModeContext.Provider value={{ mode, toggleTheme }}>
      <ThemeProvider theme={theme}>
        <CssBaseline />
        <AuthProvider>
          {getLayout(<Component {...pageProps} />)}
        </AuthProvider>
      </ThemeProvider>
    </ThemeModeContext.Provider>
  );
}

export default MyApp;
